import React from 'react'

class ModalAceptarLote extends React.Component {

    constructor(props) {
        super(props);
        this.dialogRef = React.createRef();
    }

    componentDidMount() {
        // Manejar el estado inicial del modal
        if (this.props.isOpen) {
            this.abrirModal();
        }
    }

    componentDidUpdate(prevProps) {
        // Detectar cambios en isOpen para abrir/cerrar el modal
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.abrirModal();
            } else {
                this.cerrarModalConAnimacion();
            }
        }
    }

    abrirModal = () => {
        if (this.dialogRef.current && !this.dialogRef.current.open) {
            this.dialogRef.current.showModal();
        }
    }

    cerrarModal = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.close();
        }
    }

    cerrarModalConAnimacion = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.style.scale = '0';
            setTimeout(() => {
                if (this.dialogRef.current && this.dialogRef.current.open) {
                    this.dialogRef.current.close();
                }
            }, 300);
        }
    }

    manejarCancelar = () => {
        this.cerrarModalConAnimacion();
        setTimeout(() => {
            this.props.cerrarModal();
        }, 300);
    }

    manejarConfirmar = () => {
        this.props.onConfirmar();
    }


    render() {

        const { isOpen, tipoDocumento } = this.props

        if (!isOpen) return null;
        return (
            <div className="component-modal">

                <dialog
                    className="modal"
                    id="modal-enviar-notificacion"
                    ref={this.dialogRef}
                    onClose={this.manejarCancelar}
                >
                    <div className="modal-content">

                        <div className="modal-body">
                            <h3 className="title"> ¿Desea aceptar el {tipoDocumento}? </h3>
                            <p className="msg"> El {tipoDocumento} será marcado como aceptado, confirme para finalizar el proceso. </p>
                        </div>

                        <div className="modal-footer">
                            <button onClick={this.manejarCancelar} className="btn-medium btn-base-outline" id="close-modal" type="reset"> Cancelar </button>
                            <button onClick={this.manejarConfirmar} className="btn-medium btn-primary"> Aceptar </button>
                        </div>

                    </div>
                </dialog>

            </div>
        )
    }
}
export default ModalAceptarLote;